<template>
    <van-popup v-model:show="visible" closeable position="bottom" :style="{ width: '100%' }">
        <div class="change-auth-dialog" @click.stop>
            <div class="dialog-title">变更授权</div>
            <div class="dialog-content">
                <!-- 选择新办理人 -->
                <div class="form-item">
                    <div class="form-label">
                        <span class="all_tips_red"></span>
                        <span>新办理人</span>
                    </div>
                    <div class="form-input-box" @click="showHolderPopup = true">
                        <van-field v-model="selectedHolder.applierName" readonly is-link type="text"
                            placeholder="请选择新办理人" class="form-input" />
                    </div>
                </div>

                <!-- 授权书上传 -->
                <div class="form-item">
                    <div class="form-label">
                        <span class="all_tips_red"></span>
                        <span>法定代表人授权书</span>
                    </div>
                    <div class="upload-box">
                        <van-uploader accept="image/*" v-model="authFileList" :before-read="beforeRead"
                            :after-read="(file) => afterRead(file)" preview-size="4rem" :max-count="1"
                            @delete="onDeleteAuthFile">
                            <div v-show="authFileList.length === 0" class="upload-placeholder">
                                <van-icon name="plus" size="1.5rem" color="#999" />
                                <div class="upload-text">上传授权书</div>
                            </div>
                        </van-uploader>
                    </div>
                </div>
                <div v-if="isShowAccount" class="form-item">
                    <div class="form-label">
                        <span class="all_tips_red"></span>
                        <span>完成对公打款认证，提交认证：</span>
                    </div>
                    <div class="form-content-box">
                        <div class="payment-name">使用贵公司对公账户，向以下账户打款{{ accountInfo.amount }}元</div>
                        <div class="payment-name">备注打款交易码esign</div>
                        <div class="payment-name">公司名称：{{ accountInfo.companyName }}</div>
                        <div class="payment-name">开户行名称：{{ accountInfo.bankDeposit }}</div>
                        <div class="payment-name">汇入银行账号：{{ accountInfo.bankAccount }}</div>
                        <div class="payment-name">打款金额：{{ accountInfo.amount }}元</div>
                    </div>
                </div>

                <!-- 图形验证码 -->
                <div class="form-item">
                    <div class="form-label">
                        <span class="all_tips_red"></span>
                        <span>验证码</span>
                    </div>
                    <div class="form-input-box">
                        <van-field v-model="imgVerifyCode" type="number" maxlength="6" placeholder="请输入计算结果" clearable
                            class="form-input" />
                        <img :src="verifyImg" class="verify-img" @click="getPictureImg" title="看不清，点击刷新" />
                    </div>
                </div>
            </div>

            <!-- 底部按钮 -->
            <div class="dialog-footer">
                <button class="btn-confirm" @click="handleConfirm">确定</button>
            </div>
        </div>

        <!-- 选择办理人弹框 -->
        <van-popup v-model:show="showHolderPopup" position="bottom" :style="{ width: '100%' }">
            <div class="holder-popup">
                <div class="popup-title">选择新办理人</div>
                <div class="horizontal_line"></div>
                <div class="popup-content">
                    <div v-for="item in holderList" :key="item.staffCode">
                        <div class="popup-item backgroundC_white bwhite_ative" @click="onSelectHolder(item)">
                            <div class="holder-info">
                                <div class="holder-name">{{ item.staffName }}</div>
                            </div>
                        </div>
                        <div class="horizontal_line"></div>
                    </div>
                    <van-empty v-show="holderList.length === 0" description="暂无可选办理人" />
                </div>
                <div style="height:.5rem;background-color: #ededed;"></div>
                <div class="cancel-btn" @click="showHolderPopup = false">取&nbsp;消</div>
            </div>
        </van-popup>
    </van-popup>
</template>

<script>
import Vue from 'vue';
import { Field, Popup, Uploader, Icon, Empty, Dialog } from 'vant';

Vue.use(Field);
Vue.use(Popup);
Vue.use(Uploader);
Vue.use(Icon);
Vue.use(Empty);

export default {
    name: 'ChangeAuthDialog',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        corpId: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            visible: this.show,
            // 选中的办理人
            selectedHolder: {
                applierCode: '',
                applierName: '',
            },
            // 办理人列表
            holderList: [],
            corpData: {},//企业信息
            // 显示办理人选择弹框
            showHolderPopup: false,
            // 授权书文件列表
            authFileList: [],
            // 授权书文件ID
            authFileId: '',
            // 图形验证码
            imgVerifyCode: '',
            // 图形验证码ID
            verifyId: '',
            // 图形验证码图片
            verifyImg: '',
            // 图片大小限制
            imageLimitSize: 524288,
            accountInfo: { //账户信息
                companyName: '北京国富安电子商务安全认证有限公司',
                bankDeposit: '工商银行北京经济技术开发区宏达北路支行',
                bankAccount: '0200059009024509383',
                amount: '0.01',
            },
            isShowAccount: false, //是否显示账户信息
        };
    },
    watch: {
        show(val) {
            this.visible = val;
            if (val) {
                this.init();
            }
        },
        visible(val) {
            this.$emit('update:show', val);
        }
    },
    methods: {
        // 初始化
        init() {
            this.selectedHolder = {
                applierCode: '',
                applierName: '',
            };
            this.authFileList = [];
            this.authFileId = '';
            this.imgVerifyCode = '';
            this.verifyImg = '';
            this.getPictureImg();
            this.getHolderList();
        },
        // 获取办理人列表
        getHolderList() {
            this.holderList = [];
            const params = {
                corpId: this.corpId,
            };
            this.$get('/corp/api/getCorpInfo', params).then(res => {
                if (res.success) {
                    const data = res.data || {};
                    this.corpData = data
                    this.holderList = data.corpMembers || [];
                    this.getEditAgentApply();
                } else {
                    this.$Toast(res.message || res.messageDetail || '获取办理人列表失败');
                }
            }).catch(err => {
                console.log('getHolderList error:', err);
                this.$Toast('获取办理人列表失败');
            });
        },
        getEditAgentApply() { //获取账户信息
            const params = {
                corpId: this.corpId
            }
            this.$get('/corp/api/getEditAgentApply', params).then(rel => {
                if (rel.success) {
                    const data = rel.data || {}
                    this.accountInfo = data.account || this.accountInfo
                    // 现办理人发起变更授权，仅上传授权书即可，隐藏打款信息 非现办理人申请，上传授权书并显示打款信息
                    // 或者 内部企业做打款认证时也要隐藏掉打款信息   corpFlag SI是内部 ，非SI都是外部
                    if (data.applierCode !== this.$store.state.userInfo.staffCode && this.corpData.corpFlag !== 'SI') {
                        this.isShowAccount = true
                    }
                } else {
                    this.$message.error(rel.message || '系统错误,请联系管理员')
                }
            }).finally(() => {
                this.confirmLoading = false
            })
        },
        // 选择办理人
        onSelectHolder(item) {
            console.log(item.idCode === this.corpData.legalPersonIdCode)
            if (item.idCode === this.corpData.legalPersonIdCode) {
                this.$Toast('您选择的办理人为法人，建议您通过法人账号“重新认证”完成变更，无需打款无需审核');
                return;
            }
            this.selectedHolder = {
                applierCode: item.staffCode,
                applierName: item.staffName,
            };
            this.showHolderPopup = false;
        },

        // 读取文件前
        beforeRead(file) {
            if (file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/jpg') {
                this.$Toast('请选择图片文件');
                return false;
            }
            return true;
        },

        // 文件上传
        afterRead(file) {
            file.status = 'uploading';
            file.message = '上传中...';
            if (file.file.size > this.imageLimitSize) {
                this.$store.dispatch(this.$LoadShow, true);
                this.Tool.compressImage(file, this.imageLimitSize, false).then(res => {
                    this.uploadBase64(file, res);
                    this.$store.dispatch(this.$LoadShow, false);
                }).catch(err => {
                    console.log('该图片不支持压缩', err);
                    this.uploadBase64(file, file.content);
                    this.$store.dispatch(this.$LoadShow, false);
                });
            } else {
                this.uploadBase64(file, file.content);
            }
        },

        // 上传base64
        uploadBase64(file, data) {
            this.$post('/file/api/saveBase64?resId=' + this.Tool.generateUUID(), {
                base64Data: data,
                clearBg: false,
                fileName: file.file.name
            }).then(res => {
                if (res.success && res.data) {
                    file.status = 'success';
                    file.message = '上传成功';
                    this.authFileId = res.data.fileId;
                } else {
                    file.status = 'failed';
                    file.message = '上传失败';
                    this.$Toast(res.message || '上传失败');
                }
            }).catch(err => {
                console.log('uploadBase64 error:', err);
                file.status = 'failed';
                file.message = '上传失败';
                this.$Toast('上传失败');
            });
        },

        // 删除授权书
        onDeleteAuthFile() {
            this.authFileId = '';
        },

        // 获取图形验证码
        getPictureImg() {
            this.imgVerifyCode = '';
            this.$store.dispatch(this.$LoadShow, true);
            this.$get('/login/api/getPictureImg').then(res => {
                this.$store.dispatch(this.$LoadShow, false);
                if (res.success && res.data) {
                    this.verifyId = res.data.verifyId;
                    this.verifyImg = res.data.srcImg;
                } else {
                    this.verifyImg = '';
                    this.$Toast('未获取到验证图片');
                }
            }).catch(err => {
                this.verifyImg = '';
                this.$store.dispatch(this.$LoadShow, false);
                console.log('getPictureImg error:', err);
                this.$Toast('获取验证图片失败');
            });
        },

        // 确定
        handleConfirm() {
            // 表单验证
            if (!this.selectedHolder.applierCode) {
                this.$Toast('请选择新办理人');
                return;
            }
            if (!this.authFileId) {
                this.$Toast('请上传法定代表人授权书');
                return;
            }
            if (!this.imgVerifyCode) {
                this.$Toast('请输入图形验证码');
                return;
            }

            // 提交数据
            const params = {
                corpId: this.corpId,
                ...this.selectedHolder,
                certifyWay: 2, //法人授权认证
                corpName: this.corpData.corpName,
                legalPerson: this.corpData.legalPerson,
                legalPersonIdCode: this.corpData.legalPersonIdCode,
                creditCode: this.corpData.creditCode,
                ifChangeAdmin: true, // 可以不提示 3天内不可重新认证
                authApply: {
                    authFileId: this.authFileId,
                    ...this.accountInfo,
                    verify: {
                        code: this.imgVerifyCode,
                        id: this.verifyId
                    }
                },
            };
            if (!this.isShowAccount) { //现办理人发起变更授权 接口金额参数为0
                params.authApply.amount = 0
            }
            Dialog.confirm({
                title: '提示',
                message: `您企业授权的原办理人为：${this.corpData?.applierName}，变更后新办理人为：${this.selectedHolder?.applierName}，请确认授权书中被授权人与新办理人保持一致，否则可能被审核机构驳回！是否继续？`,
                confirmButtonText: '确定',
                confirmButtonColor: '#0277FC'
            }).then(() => {
                this.$store.dispatch(this.$LoadShow, true);
                this.$post('/corp/api/submitAgentApply', params).then(res => {
                    this.$store.dispatch(this.$LoadShow, false);
                    if (res.success) {
                        this.$Toast('变更授权成功！');
                        this.$emit('confirm');
                    } else {
                        this.getPictureImg()
                        this.$Toast(res.message || res.messageDetail || '变更授权失败！');
                    }
                }).catch(err => {
                    this.$store.dispatch(this.$LoadShow, false);
                    this.$Toast('变更授权失败！');
                });
            }).catch(() => {
                this.$store.dispatch(this.$LoadShow, false)
            });
        },

        // 关闭弹框
        closeDialog() {
            this.visible = false;
        }
    }
};
</script>

<style scoped lang="scss">
@import "../../../styles/global.css";

::v-deep .van-image__img {
    object-fit: contain !important;
}

.change-auth-dialog {
    padding-top: 1rem;

    .dialog-title {
        font-size: 0.9rem;
        font-weight: 700;
        color: #333;
        text-align: center;
        margin-bottom: 0.8rem;
    }

    .dialog-content {
        max-height: 15rem;
        overflow-y: auto;

        .form-item {
            margin-bottom: 0.5rem;
            padding: 0 0.8rem;

            .form-label {
                font-size: 0.7rem;
                color: #666;
                margin-bottom: 0.3rem;
                line-height: 1.2rem;
            }

            .form-input-box {
                display: flex;
                align-items: center;
                border-bottom: 1px solid #ccc;
                padding-bottom: 0.1rem;

                .form-input {
                    flex: 1;
                }

                .verify-img {
                    width: 4rem;
                    height: 1.5rem;
                    cursor: pointer;
                }
            }

            .form-content-box {
                font-size: 0.7rem;
                color: #323233;
                padding: 0 0.3rem 0.3rem 0.3rem;
                border-bottom: 1px solid #ccc;

                .payment-name {
                    padding-top: .2rem;
                }
            }

            .upload-box {
                margin-top: 0.3rem;

                .upload-placeholder {
                    width: 4rem;
                    height: 4rem;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    background: #f5f7fa;
                    border-radius: 0.2rem;

                    .upload-text {
                        font-size: 0.6rem;
                        color: #999;
                        margin-top: 0.2rem;
                    }
                }
            }
        }
    }

    .dialog-footer {
        border-top: 1px solid #ccc;
        padding: 0.8rem;

        .btn-confirm {
            width: 100%;
            height: 2.2rem;
            border-radius: 0.2rem;
            font-size: 0.8rem;
            background-color: #0277FC;
            color: #fff;
        }
    }
}

.holder-popup {
    .popup-title {
        font-size: 0.9rem;
        font-weight: 700;
        color: #333;
        text-align: center;
        padding: 0.5rem;
    }

    .popup-content {
        max-height: 15rem;
        overflow-y: auto;

        .popup-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0.6rem 0.8rem;

            .holder-info {
                .holder-name {
                    font-size: 0.75rem;
                    color: #333;
                }

                .holder-phone {
                    font-size: 0.65rem;
                    color: #999;
                    margin-top: 0.2rem;
                }
            }
        }
    }

    .cancel-btn {
        font-size: 0.7rem;
        text-align: center;
        height: 2.4rem;
        line-height: 2.4rem;
        color: #999;
        border-top: 1px solid #ccc;
    }
}

::v-deep .van-field {
    padding: 0.3rem 0;

    .van-field__control {
        font-size: 0.7rem;
    }
}
</style>